import { render, staticRenderFns } from "./MousaProductSection.vue?vue&type=template&id=29024555&"
import script from "./MousaProductSection.vue?vue&type=script&lang=js&"
export * from "./MousaProductSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports